<section class="card">
  <app-card-lg *ngFor="let card of cardList" [inputObject]="card" [selected]="card.id === selectedId" (cardSelect)="setSelected($event)"></app-card-lg>
</section>
